import { Outlet } from "react-router-dom";
import Header from "./Header";
import TopMenu from "./TopMenu";
import Footer from "./Footer";

export default function StoreLayout({ cartCount }) {
    return (
        <div className="d-flex flex-column min-vh-100">
            {/* الجزء العلوي الثابت للعميل */}
            <Header cartCount={cartCount} />
            <TopMenu />

            {/* مساحة المحتوى المتغير (الرئيسية، صفحة المنتج، السلة، الخ) */}
            <main className="flex-grow-1">
                <Outlet />
            </main>

            {/* الجزء السفلي الثابت للعميل */}
            <Footer />
        </div>
    );
}